import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { InvoicePerformaComponent } from "./invoice-performa.component";
import { ProformaInvoiceComponent } from "./proforma-invoice/proforma-invoice.component";
import { AddProformaInvoiceComponent } from "./add-proforma-invoice/add-proforma-invoice.component";
const routes: Routes = [
  {
    path: "",
    redirectTo: "invoice-details",
    pathMatch: "full",
    data: { title: "Proforma Invoice" },
  },
  {
    path: "invoice-details",
    component: InvoicePerformaComponent,
    data: { title: "Proforma Invoice" },
  },
  {
    path: "performa-invoice/:id",
    component: ProformaInvoiceComponent,
    data: { title: "Tax Proforma Invoice" },
  },
  {
    path: "add-view-invoice/:id",
    component: AddProformaInvoiceComponent,
    data: { title: "Manage Proforma Invoice" },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InvoicePerformaRoutingModule {}
